import { useModal } from "react-modal-hook";
import { WorkflowStepManualStatus } from "../../generated/graphql";
import Modal from "../Common/Modal";
import { UpdateWorkflowStepStatusModal } from "./UpdateWorkflowStepStatusModal";

export const useUpdateWorkflowStepStatusModal = ({
  workflowStepId,
  workflowStepManualStatus,
  submissionTypeName,
  onUpdate,
}: {
  workflowStepId: string;
  workflowStepManualStatus: WorkflowStepManualStatus;
  submissionTypeName: string;
  onUpdate: () => void;
}) => {
  const [showModal, hideModal] = useModal(
    () => (
      <Modal onRequestClose={hideModal}>
        <UpdateWorkflowStepStatusModal
          workflowStepId={workflowStepId}
          currentStatus={workflowStepManualStatus}
          submissionTypeName={submissionTypeName}
          onCancel={hideModal}
          onSuccess={() => {
            onUpdate();
            hideModal();
          }}
        />
      </Modal>
    ),
    [workflowStepId, workflowStepManualStatus, submissionTypeName, onUpdate],
  );

  return [showModal, hideModal] as const;
};
